import { toggleContentOverlay } from "../layout/helper";

// Select all elements from the DOM
const openButtons = document.querySelectorAll(".cart-toggle");
const closeBtn = document.querySelector("#cart-close-btn");
const cartModal = document.querySelector("#cart-modal");

// Add eventlistener to all open buttons on click
openButtons?.forEach((btn) => {
    // Toggle cart modal on button click
    btn.addEventListener("click", () => {
        cartModal.setAttribute("aria-hidden", false);
        document.body.classList.add("cart-modal-toggled");
        document.body.classList.add("overflow-hidden");
        toggleContentOverlay(true);
    });
});

// Add eventlistener to close button (inside of modal) on click
closeBtn?.addEventListener("click", () => {
    cartModal.setAttribute("aria-hidden", true);
    document.body.classList.remove("cart-modal-toggled");
    document.body.classList.remove("overflow-hidden");
    toggleContentOverlay(false);
});